import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

// Geleneksel uygulamalar (Faz 5): uygulama türü kataloğu, seans kaydı,
// onam formu şablonları / kayıtları ve kliniğin onam ayarı.
const ADMIN_PRACTICES = "/api/admin/system-variables/traditional-practices";
const CLINIC_PRACTICES = "/api/clinic/system-variables/traditional-practices";
const SESSIONS = "/api/clinic/practice-sessions";
const CONSENTS = "/api/clinic/consents";

const post = (url) => ({ query: (d) => apiFunction(d, url, "POST") });

export const traditionalApi = createApi({
  reducerPath: "traditionalApi",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (b) => ({
    // ── Katalog (admin sistem değişkeni) ──
    listTraditionalPractices: b.mutation(post(`${CLINIC_PRACTICES}/list`)),
    createTraditionalPractice: b.mutation(post(`${ADMIN_PRACTICES}/create`)),
    updateTraditionalPractice: b.mutation(post(`${ADMIN_PRACTICES}/update`)),
    setTraditionalPracticeStatus: b.mutation(post(`${ADMIN_PRACTICES}/status`)),
    deleteTraditionalPractice: b.mutation(post(`${ADMIN_PRACTICES}/delete`)),

    // ── Seanslar ──
    listPracticeSessionsByPatient: b.mutation(post(`${SESSIONS}/list-by-patient`)),
    listClinicPracticeSessions: b.mutation(post(`${SESSIONS}/list-by-clinic`)),
    checkPracticeSession: b.mutation(post(`${SESSIONS}/check`)),
    createPracticeSession: b.mutation(post(`${SESSIONS}/create`)),
    updatePracticeSession: b.mutation(post(`${SESSIONS}/update`)),
    // Seans başına mobil onay: "Onay bekliyor" seansta bildirimi yenile / kağıtla tamamla
    resendSessionConsent: b.mutation(post(`${SESSIONS}/resend-consent`)),
    confirmSessionConsentPaper: b.mutation(post(`${SESSIONS}/confirm-paper`)),

    // ── Onam ──
    listConsentTemplates: b.mutation(post(`${CONSENTS}/templates/list`)),
    createConsentTemplate: b.mutation(post(`${CONSENTS}/templates/create`)),
    updateConsentTemplate: b.mutation(post(`${CONSENTS}/templates/update`)),
    deleteConsentTemplate: b.mutation(post(`${CONSENTS}/templates/delete`)),
    listPatientConsents: b.mutation(post(`${CONSENTS}/list-by-patient`)),
    createConsentRecord: b.mutation(post(`${CONSENTS}/create`)),
    sendConsentRequest: b.mutation(post(`${CONSENTS}/requests/send`)),
    listConsentRequests: b.mutation(post(`${CONSENTS}/requests/list`)),
    cancelConsentRequest: b.mutation(post(`${CONSENTS}/requests/cancel`)),
    getConsentSettings: b.mutation(post(`${CONSENTS}/settings`)),
    updateConsentSettings: b.mutation(post(`${CONSENTS}/settings/update`)),
  }),
});

export const {
  useListTraditionalPracticesMutation,
  useCreateTraditionalPracticeMutation,
  useUpdateTraditionalPracticeMutation,
  useSetTraditionalPracticeStatusMutation,
  useDeleteTraditionalPracticeMutation,
  useListPracticeSessionsByPatientMutation,
  useListClinicPracticeSessionsMutation,
  useCheckPracticeSessionMutation,
  useCreatePracticeSessionMutation,
  useUpdatePracticeSessionMutation,
  useResendSessionConsentMutation,
  useConfirmSessionConsentPaperMutation,
  useListConsentTemplatesMutation,
  useCreateConsentTemplateMutation,
  useUpdateConsentTemplateMutation,
  useDeleteConsentTemplateMutation,
  useListPatientConsentsMutation,
  useCreateConsentRecordMutation,
  useSendConsentRequestMutation,
  useListConsentRequestsMutation,
  useCancelConsentRequestMutation,
  useGetConsentSettingsMutation,
  useUpdateConsentSettingsMutation,
} = traditionalApi;
